// Note: make sure not to include date fields for write operations as they are automatically updated by the server
export const FIRESTORE_WRITE_WHITELISTED_FIELDS = {
    'opportunities': ['location_id', 'status', 'pipeline_id', 'pipeline_stage_id']
}